// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__yJ+4c","icon":"styles_icon__60gSR"};